import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { AppState } from '../../../../../types/store';
import {
  getProfileOwnerUser,
  isCurrentUserProfileOwner,
} from '../../../../selectors/users';
import {
  getModuleType,
  getModuleMeta,
  getModuleVersion,
} from '../../../../selectors/modules';
import { getCanCurrentUserEditModule } from '../../../../selectors/layout';
import { updateModule } from '../../../../actions/modules';
import { Props } from './WidgetBox';
import { ComponentType } from 'react';

export type ConnectedKeys =
  | 'profileOwnerUser'
  | 'isCurrentUserProfileOwner'
  | 'moduleType'
  | 'moduleVersion'
  | 'canUserEditWidget'
  | 'isNewlyAddedModule';
export type StateProps = Pick<Props, ConnectedKeys>;
export type DispatchProps = Pick<Props, 'updateModule'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  ownProps
) => ({
  profileOwnerUser: getProfileOwnerUser(state),
  isCurrentUserProfileOwner: isCurrentUserProfileOwner(state),
  moduleType: getModuleType(state, ownProps.moduleId),
  moduleVersion: getModuleVersion(state, ownProps.moduleId),
  isNewlyAddedModule: getModuleMeta(state, ownProps.moduleId).isNewlyAdded,
  canUserEditWidget: getCanCurrentUserEditModule(
    state,
    ownProps.section,
    ownProps.zone,
    ownProps.moduleId
  ),
});
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  updateModule,
};

export default connect(mapStateToProps, mapDispatchToProps) as (
  component: ComponentType<Props>
) => ComponentType<Omit<Props, ConnectedKeys>>;
